export const blockIconsNotificationWc = (
	<span className='material-symbols-outlined'>wc</span>
);
